<div class="row mb-2">
  <div class="col-md-2">
    <select class="form-control" [(ngModel)]="searchBy">
      <option value="">Select Search By</option>
      <option value="driverName">Driver Name</option>
      <option value="phoneNumber">Mobile Number</option>
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
      (click)="search()"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div>

  <div class="col-md-6 m-0 text-end">
    <button
      style="margin: 0px 5px 0px 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
      (click)="exportToExcel()"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <button class="btn-shadow d-inline-flex align-items-center btn btn-success" (click)="exportAll()">
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
    </button>
  </div>
</div>

<!-- Transaction History Table -->
<div class="card shadow-sm">
  <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="mb-0">Withdrawal Requests</h5>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table
        class="table table-bordered table-hover mb-0"
        id="transactionTable"
      >
        <thead class="table-light">
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Phone Number</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="fw-bold" *ngFor="let data of withdrawalRequests">
            <td>
              {{
                data.timestamp * 1000 | date : "dd MMM yyyy hh:mm a" : "en-IN"
              }}
            </td>
            <td>{{ data.driverName }}</td>
            <td>{{ data.phoneNumber }}</td>
            <td><i class="fa fa-inr"></i> {{ data.amount }}</td>
            <td
              class="text-center"
              [ngClass]="{
                ' text-success': data.status === 'APPROVED',
                ' text-danger': data.status === 'REJECTED',
                ' text-warning': data.status === 'PENDING'
              }"
            >
              {{ data.status }}
              <span class="text-primary" *ngIf="data.status == 'REJECTED'"
                >:{{ data.rejectedReason }}</span
              >
            </td>
            <td class="action-buttons">
              <button
                class="btn btn-success btn-sm"
                data-toggle="tooltip"
                data-placement="top"
                title="Approve Request"
                [disabled]="data.status !== 'PENDING'"
                (click)="updateWithdrawalRequest(data._id, 'APPROVED')"
              >
                Approve
              </button>
              <button
                class="btn btn-danger btn-sm"
                data-toggle="tooltip"
                data-placement="top"
                title="Reject Request"
                [disabled]="data.status !== 'PENDING'"
                (click)="rejectModel(content, data)"
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>

<!-- Rejection Reason Modal -->
<div class="card-body modal-lg">
  <ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header d-flex justify-content-between align-items-center">
      <h4
        class="modal-title d-flex align-items-center fw-semibold mb-3 text-primary"
      >
        <i class="fa fa-edit me-2"></i>Select Rejection Reason
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>

    <div class="modal-body">
      <form>
        <!-- Rejection Reason -->
        <div class="mb-4">
          <div class="row font-size-lg">
            <div class="col-12">
              <div class="form-check">
                <input
                  type="radio"
                  id="invalidDetails"
                  name="rejectReason"
                  value="Invalid Details"
                  class="form-check-input"
                  (change)="onReasonSelect('Invalid Details')"
                />
                <label for="invalidDetails" class="form-check-label"
                  >Invalid Details</label
                >
              </div>
            </div>
            <div class="col-12">
              <div class="form-check">
                <input
                  type="radio"
                  id="duplicateRequest"
                  name="rejectReason"
                  value="Duplicate Request"
                  class="form-check-input"
                  (change)="onReasonSelect('Duplicate Request')"
                />
                <label for="duplicateRequest" class="form-check-label"
                  >Duplicate Request</label
                >
              </div>
            </div>
            <div class="col-12">
              <div class="form-check">
                <input
                  type="radio"
                  id="insufficientFunds"
                  name="rejectReason"
                  value="Insufficient Funds"
                  class="form-check-input"
                  (change)="onReasonSelect('Insufficient Funds')"
                />
                <label for="insufficientFunds" class="form-check-label"
                  >Insufficient Funds</label
                >
              </div>
            </div>
            <div class="col-12">
              <div class="form-check">
                <input
                  type="radio"
                  id="other"
                  name="rejectReason"
                  value="false"
                  class="form-check-input"
                  (change)="onReasonSelect('Other')"
                />
                <label for="other" class="form-check-label">Other</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Custom Reason Input (Appears if 'Other' is selected) -->
        <div class="mb-4 font-size-lg" *ngIf="showOtherReason">
          <!-- <label  class="form-label fw-semibold">Custom Reason</label> -->
          <input
            class="form-control"
            type="text"
            name="otherReason"
            id="otherReason"
            placeholder="Enter a reason..."
            [(ngModel)]="rejectReason"
            required
          />
          <small class="form-text text-muted"> Please specify a reason. </small>
        </div>
      </form>
    </div>

    <div class="modal-footer justify-content-between">
      <!-- Action Buttons -->
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="d('Cancel click')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-danger"
        [disabled]="!rejectReason"
        (click)="updateWithdrawalRequest(modelId, 'REJECTED')"
      >
        Confirm Rejection
      </button>
    </div>
  </ng-template>
</div>
